var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_562_10800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.25033V1.16699H10.5V5.25033",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50033 10.5H2.33366C2.02424 10.5 1.72749 10.3771 1.5087 10.1583C1.28991 9.9395 1.16699 9.64275 1.16699 9.33333V6.41667C1.16699 6.10725 1.28991 5.8105 1.5087 5.59171C1.72749 5.37292 2.02424 5.25 2.33366 5.25H11.667C11.9764 5.25 12.2732 5.37292 12.492 5.59171C12.7107 5.8105 12.8337 6.10725 12.8337 6.41667V9.33333C12.8337 9.64275 12.7107 9.9395 12.492 10.1583C12.2732 10.3771 11.9764 10.5 11.667 10.5H10.5003",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.16699H3.5V12.8337H10.5V8.16699Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_562_10800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.03a0d6b1613d9b7d281e5ba62e5655d6.svg";
export { ForwardRef as ReactComponent };